import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

import sharedStyles from '../Shared.module.scss';
import * as Shared from '../Shared.styles';

export interface ScenarioReadyToRunProps {
  assetsCount: number;
  conditionsCount: number;
  runConditionsOnClick: () => void;
}

export const ScenarioReadyToRun = ({
  assetsCount,
  conditionsCount,
  runConditionsOnClick,
}: ScenarioReadyToRunProps) => {
  const { t } = useTranslation('scenario');
  const { trackScenarioRan } = usePosthogEvents();

  const title = `${t('scenario:emptyState.assetsAnd', {
    count: assetsCount,
  })} ${t('scenario:emptyState.conditionsSelected', {
    count: conditionsCount,
  })}`;

  return (
    <Shared.Container data-testid="scenario-ready-to-run">
      <Shared.Img src="/app/static/images/icons/no-assets-found.svg" alt="" />
      <Shared.Description>
        <Shared.Title>{title}</Shared.Title>
        <Button
          className={sharedStyles.styledButton}
          variant="primary"
          label={t('scenario:buttonLabels.runScenario')}
          data-testid="run-scenario"
          onClick={() => {
            trackScenarioRan(POSTHOG_TRACKING_SOURCES.SCENARIO);
            runConditionsOnClick();
          }}
        />
      </Shared.Description>
    </Shared.Container>
  );
};
